<template>
    <div>
        <page-title>授权警告</page-title>
        <page-body>
            <list-header>
                <div flex="dir:left box:last cross:center">
                    <div>
                    </div>
                    <div>
                        <el-form :inline="true">
                            <el-form-item style="margin-bottom: 0; max-width: 180px">
                                <el-select v-model="searchForm.type" clearable size="mini" placeholder="类型"
                                           @change="search()">
                                    <el-option v-for="item in searchTypeOptions" :key="item.value" :label="item.label"
                                               :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item style="margin-bottom: 0; max-width: 150px">
                                <el-input v-model="searchForm.keyword"
                                          @keyup.enter.native="search()"
                                          size="mini"
                                          placeholder="站点名称/域名"
                                          suffix-icon="el-icon-search"/>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </list-header>
            <el-table v-loading="loading" :data="list" style="width: 100%">
                <el-table-column width="200" label="站点">
                    <template slot-scope="scope">
                        <div>{{scope.row.host.name}}</div>
                        <div style="font-size: 12px;color: #909090">{{scope.row.host.domain}}</div>
                    </template>
                </el-table-column>
                <el-table-column width="170" label="类型">
                    <template slot-scope="scope">
                        <template v-if="scope.row.type===1">插件未授权安装</template>
                        <template v-if="scope.row.type===2">独立版子账号超出限制</template>
                        <template v-if="scope.row.type===3">商城数量超出限制</template>
                    </template>
                </el-table-column>
                <el-table-column width="300" label="详情">
                    <template slot-scope="scope">
                        <template v-if="scope.row.type===1">
                            <div v-for="(plugin, index) in scope.row.data" :key="index" flex="box:first">
                                <div style="min-width: 100px">{{plugin.display_name}}</div>
                                <div v-if="plugin.state" style="color: #67C23A">已授权</div>
                                <div v-else style="color: #F56C6C">未授权</div>
                            </div>
                        </template>
                        <template v-if="scope.row.type===2">
                            <div flex="box:first">
                                <div style="min-width: 100px">授权数量</div>
                                <div>{{scope.row.data.auth_account_num}}</div>
                            </div>
                            <div flex="box:first">
                                <div style="min-width: 100px">实际数量</div>
                                <div>{{scope.row.data.sub_account_num}}</div>
                            </div>
                        </template>
                        <template v-if="scope.row.type===3">
                            <div flex="box:first">
                                <div style="min-width: 100px">授权数量</div>
                                <div>1</div>
                            </div>
                            <div flex="box:first">
                                <div style="min-width: 100px">实际数量</div>
                                <div>{{scope.row.data.app_num}}</div>
                            </div>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column label="时间">
                    <template slot-scope="scope">
                        <el-tooltip class="item" content="添加时间" placement="left">
                            <div style="color: #909399; font-size: 12px;">{{scope.row.add_time}}</div>
                        </el-tooltip>
                        <el-tooltip class="item" content="更新时间" placement="left">
                            <div style="color: #909399; font-size: 12px;">{{scope.row.update_time}}</div>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    style="margin: 20px -5px;padding: 0"
                    background
                    layout="prev, pager, next"
                    @current-change="pageChange"
                    :total="parseInt(pagination && pagination.totalCount ? pagination.totalCount : 0)">
            </el-pagination>
        </page-body>
    </div>
</template>

<style scoped>

</style>

<script>
import axios from '@/axios'

export default {
    data() {
        return {
            searchForm: {
                keyword: null,
                type: null
            },
            searchTypeOptions: [

                {
                    value: 1,
                    label: '插件未授权安装'
                },
                {
                    value: 2,
                    label: '独立版子账号超出限制'
                },
                {
                    value: 3,
                    label: '商城数量超出限制'
                }
            ],
            loading: false,
            list: null,
            pagination: null
        }
    },
    created() {
        this.loadData(0)
    },
    methods: {
        loadData(page) {
            this.getList(page).then(e => {
                this.list = e.list
                this.pagination = e.pagination
            })
        },
        getList(page) {
            return new Promise(resolve => {
                this.loading = true
                axios({
                    url: 'admin/host/auth-warning',
                    params: {
                        page: page,
                        type: this.searchForm.type,
                        keyword: this.searchForm.keyword
                    }
                }).then(e => {
                    this.loading = false
                    if (e.data.code === 0) {
                        resolve(e.data.data)
                    } else {
                        this.$message.error(e.data.msg)
                    }
                })
            })
        },
        search() {
            this.loadData(0)
        },
        pageChange(page) {
            this.loadData(page - 1)
        }
    }
}
</script>
